import React, { FC } from "react";

import { faBarsSort } from "@fortawesome/pro-solid-svg-icons/faBarsSort";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import LeaderboardMetricFieldName from "@mapmycustomers/shared/enum/fieldModel/LeaderboardMetricFieldName";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { Button } from "@mapmycustomers/ui";

import MetricDropdown from "@app/component/MetricDropdown";
import SortOrder from "@app/scene/dashboard/components/Sidebar/enum/SortOrder";
import isNegativeMetric from "@app/scene/dashboard/components/Sidebar/utils/isNegativeMetric";
import PerformanceFilters from "@app/scene/dashboard/types/PerformanceFilters";

import Filters from "./components/Filters";
import SortSwitch from "./components/SortSwitch";
import styles from "./ViewControls.module.scss";

interface Props {
  className?: string;
  filters: PerformanceFilters;
  onFiltersChange?: (filters: PerformanceFilters) => void;
  onRankingMetricChange?: (metric: IField) => void;
  onSortChange?: (sort: SortOrder) => void;
  rankingMetric: IField;
  sort: SortOrder;
}

const ViewControls: FC<Props> = ({
  className,
  filters,
  onFiltersChange,
  onRankingMetricChange,
  onSortChange,
  rankingMetric,
  sort,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      <SortSwitch className={styles.sort} onChange={onSortChange} value={sort} />
      <div className={styles.filteringControls}>
        <MetricDropdown activeMetric={rankingMetric} onSelect={onRankingMetricChange}>
          <Button
            data-action-id="stack-rank-ranking-metric-menu"
            leftIcon={
              <FontAwesomeIcon
                flip={
                  isNegativeMetric(rankingMetric.name as LeaderboardMetricFieldName)
                    ? "vertical"
                    : undefined
                }
                icon={faBarsSort}
              />
            }
            type="filled"
          >
            {rankingMetric.displayName}
          </Button>
        </MetricDropdown>
        <Filters
          filters={filters}
          onFiltersChange={onFiltersChange}
          rankingMetric={rankingMetric}
        />
      </div>
    </div>
  );
};

export default ViewControls;
